var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.5C14.5 11.364 11.364 14.5 7.5 14.5C3.636 14.5 0.5 11.364 0.5 7.5C0.5 3.636 3.636 0.5 7.5 0.5C11.364 0.5 14.5 3.636 14.5 7.5ZM5.169 11.196H6.751V8.711H8.179C8.711 8.711 9.173 8.613 9.579 8.41C9.985 8.207 10.3 7.927 10.517 7.556C10.741 7.185 10.853 6.758 10.853 6.261C10.853 5.764 10.741 5.337 10.517 4.959C10.293 4.588 9.978 4.301 9.579 4.098C9.173 3.895 8.704 3.797 8.179 3.797H5.169V11.196ZM6.751 5.127H8.032C8.403 5.127 8.704 5.232 8.921 5.435C9.138 5.638 9.25 5.918 9.25 6.268C9.25 6.618 9.138 6.891 8.921 7.094C8.704 7.297 8.403 7.402 8.032 7.402H6.751V5.127Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.318bd46c047f8a843f5efaec4764ec0a.svg";
export { ForwardRef as ReactComponent };